#import "../fragments/email-sequence-template-full-fragment.graphql"

mutation DuplicateEmailSequenceTemplate($input: EmailSequenceTemplateDuplicateInput!) {
    emailSequenceTemplateDuplicate(input: $input) {
        emailSequenceTemplate {
            ...EmailSequenceTemplateFullFragment
        }
    }
}
